import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { ChartComponent, ChartType, GaugeInputs } from '@charts';
import { ChartCardComponent } from '../../chart-card/chart-card.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { ChartHeader } from '@charts';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChartCardComponent,
    ChartComponent,
    TranslocoDirective,
    ChartHeader,
],
  selector: 'ui-rsabt-losses-chart',
  template: `
    <ng-container *transloco="let t">
      <ui-chart-card class="h-full">
        <div class="flex flex-col justify-between h-full w-full">
          <chart-header
            [title]="t('CHARTS.LOSSES.TITLE')"
          />
              <chart
                class="mx-4"
                [type]="chartType()"
                [typeInputs]="gaugeInputs()"
              />
          <div></div>
        </div>
      </ui-chart-card>
    </ng-container>
  `,
})
export class RsabtLossesChartComponent {
  gaugeInputs = input.required<GaugeInputs>();

  chartType = signal<ChartType>('gauge');
}
